import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { ListColumn } from 'src/app/models/list-column.model';
import { CareerService } from 'src/app/services/career.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { CareerFilterComponent } from './career-filter/career-filter.component';
import { SpinnerService } from 'src/app/services/shared/spinner.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { PermissionService } from 'src/app/services/permission.service';
import { DISTRIBUTOR_ID, OEM_ID, ROLE_NAME, USER_ID } from 'src/app/utils/constants';
import Swal from 'sweetalert2';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import { ExportComponent } from '../../distributor/export/export.component';


@Component({
  selector: 'app-super-admin-careers',
  templateUrl: './super-admin-careers.component.html',
  styleUrls: ['./super-admin-careers.component.scss']
})
export class SuperAdminCareersComponent implements OnInit {
  @Input() from: string = '';
  @Output() viewActive = new EventEmitter<any>();
  @Output() updateActive = new EventEmitter<any>();
  @Output() addActive = new EventEmitter<boolean>();
  @Output() endCustomerSelctedAction = new EventEmitter<any>();
  @Output() exhibitionid = new EventEmitter<string>();
  public MweConstants = MweConstants;
  roleName: any = 'SUPER_ADMIN';
  columns: ListColumn[] = [];
  objects = [
    { id: 1, name: "Total Jobs", image: "assets/images/icons/OEM_totalPublished.svg", count: 0, code: 'totalJobs' },
    { id: 2, name: "Total Active Jobs", image: "assets/images/icons/OEM_totalIncomplete.svg", count: 0, code: 'totalActive' },
    { id: 3, name: "Total Inactive Jobs", image: "assets/images/icons/OEM_totalHide.svg", count: 0, code: 'totalInactive' },
    { id: 4, name: "Total Applicants", image: "assets/images/icons/OEM_totalRequired.svg", count: 0, code: 'totalApplicants' },
  ];
  data: any[] = [];
  filterObject: any = {};
  showNoRecordsFounds: boolean = true;
  searchKeyword: string = '';
  selectedData: any;
  isDesktopView: boolean = false;
  isXLLaptopView: boolean = false;
  isLargeLaptopView: boolean = false;
  private userIdByRole: any;
  oemId:any = "";

  page: number = 0;
  pageSize: number = 10;
  keyWord: string = '';
  private readonly FILTER_STORAGE_KEY = 'careerFilterState';
  private readonly SEARCH_STORAGE_KEY = 'careerSearchState';
  private readonly CHIPS_STORAGE_KEY = 'careerChipsState';
  searchValue: string = '';
  searchTerm: string = '';
  isFiltered: boolean = false;
  fieldsToExport: string[] = ['id','jobPostId', 'title', 'image',  'category', 'jobType', 'totalApplicants', 'company', 'country', 'postedBy', 'postedEmail', 'applicationStartDate', 'salaryRange', 'salaryFrom', 'salaryTo', 'description', 'active', 'hideSalary', 'postAnonymously', 'createdOn'];
  chips: { name: string, type: string }[] = [];

  permissions = [];
  hasAddPermission: boolean = true;
  hasViewPermission: boolean = true;
  hasEditPermission: boolean = true;
  hasDeletePermission: boolean = true;
  isPagination: boolean = true;
  showPagination: boolean = true;
  totalEntries: number = 0;


  constructor(
    public dialog: MatDialog,
    private careerService: CareerService,
    private breakpointObserver: BreakpointObserver,
    private snackbarService: SnackbarService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private spinnerService: SpinnerService,
    private localStorageService: LocalStorageService,
    private permissionService: PermissionService,
    private sweetAlertService: SweetAlertService
  ) {
    this.oemId = this.localStorageService.getItem('roleName') === 'DISTRIBUTOR'
          ? this.localStorageService.getItem(DISTRIBUTOR_ID)
          : (this.localStorageService.getItem('roleName') === 'OEM'
            ? this.localStorageService.getItem(OEM_ID)
            : this.localStorageService.getItem(USER_ID));
        this.roleName = localStorageService.getItem('roleName');
    this.breakpointObserver.observe(
      ["(min-width: 1920px)", "(min-width: 1536px)"]
    ).subscribe((result: BreakpointState) => {
      if (result.breakpoints['(min-width: 1920px)']) {
        this.isDesktopView = true;
      } else if (result.breakpoints['(min-width: 1536px)']) {
        this.isXLLaptopView = true;
      } else if (result.breakpoints['(max-width: 1366px)']) {
        this.isLargeLaptopView = true;
      } else {
      }
    });
  }

  ngOnInit(): void {
    this.roleName = this.localStorageService.getItem('roleName');
    this.initializeColumns();
    this.careerService.setCareersBreadCrumbs(['Dashboard', 'Jobs']);
    if(this.localStorageService.getItem('preferences') &&this.localStorageService.getItem('preferences').length>0){
      this.updatePermissions();
    }
    this.restorePreviousFiltersAndSearch();
    this.getAllJobPostByFilter();
  }
  initializeColumns() {
    this.columns = [
      { name: 'Sr.No', property: 'sNo', visible: true, isModelProperty: false },
      { name: 'Job Title', property: 'title', visible: true, isModelProperty: true, isText: true },
      { name: 'Job ID', property: 'jobPostId', visible: true, isModelProperty: true, isSecondaryLink: true, secondaryAction: MweConstants.viewAction },
      { name: 'Total Applicants', property: 'totalApplicants', visible: true, isModelProperty: true, isSecondaryLink: true, secondaryAction: MweConstants.viewJobApplicationsAction },
      { name: 'Posted Company', property: 'company', visible: true, isModelProperty: true, isText: true },
      { name: 'Country', property: 'country', visible: true, isModelProperty: true, isText: true },
      { name: 'Posted by', property: 'postedBy', visible: true, isModelProperty: true, isText: true },
      { name: 'Email Address', property: 'postedEmail', visible: true, isModelProperty: true, isText: true },
      { name: 'posted On', property: 'createdOn', visible: true, isModelProperty: true, isDatePipe: true },
      { name: 'Status', property: 'active', visible: true, isModelProperty: true, isStatus: true },
      { name: 'Category', property: 'category', visible: true, isModelProperty: true, isText: true },
      // { name: 'Other Category', property: 'otherJobCategory', visible: this.roleName === 'SUPER_ADMIN', isModelProperty: true, isText: true },
      // { name: 'Job Type', property: 'jobType', visible: true, isModelProperty: true, isText: true },
      // { name: 'Other JobType', property: 'otherJobType', visible: this.roleName === 'SUPER_ADMIN', isModelProperty: true, isText: true },
      // { name: 'Career Level', property: 'careerLevel', visible: true, isModelProperty: true, isText: true },
      // { name: 'Other Carrer Level', property: 'otherCareerLevel', visible: this.roleName === 'SUPER_ADMIN', isModelProperty: true, isText: true },
      // { name: 'Degree Level', property: 'degreeLevel', visible: this.roleName === 'SUPER_ADMIN', isModelProperty: true, isText: true },
      // { name: 'Other Degree Level', property: 'otherDegreeLevel', visible: this.roleName === 'SUPER_ADMIN', isModelProperty: true, isText: true },
      // { name: 'Tags', property: 'tags', visible: this.roleName === 'SUPER_ADMIN', isModelProperty: true, isText: true },
      // { name: 'Other Tags', property: 'otherTags', visible: this.roleName === 'SUPER_ADMIN', isModelProperty: true, isText: true },
      {
        name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
        actions: [
          { imageUrl: 'assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
          { imageUrl: 'assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
          { imageUrl: 'assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
        ]
      },
    ] as ListColumn[];
  }


  restorePreviousFiltersAndSearch() {
    const savedFilter = sessionStorage.getItem(this.FILTER_STORAGE_KEY);
    if (savedFilter) {
      this.filterObject = JSON.parse(savedFilter);
      this.isFiltered = true;
    }
    const savedSearch = sessionStorage.getItem(this.SEARCH_STORAGE_KEY);
    if (savedSearch) {
      this.searchValue = savedSearch;
      this.keyWord = savedSearch;
    }
    const savedChips = sessionStorage.getItem(this.CHIPS_STORAGE_KEY);
    if (savedChips) {
      this.chips = JSON.parse(savedChips);
    }
  }

  updatePermissions(){
    this.permissions=this.localStorageService.getItem('preferences')
    this.hasAddPermission=this.permissionService.hasPermission('CAREER_CREATE',this.permissions);
    this.hasViewPermission=this.permissionService.hasPermission('CAREER_VIEW',this.permissions);
    this.hasEditPermission=this.permissionService.hasPermission('CAREER_EDIT',this.permissions);
    this.hasDeletePermission=this.permissionService.hasPermission('CAREER_DELETE',this.permissions);
    let columns=[
      { name: 'Sr.No', property: 'sNo', visible: true, isModelProperty: false },
    { name: 'Job Title', property: 'title', visible: true, isModelProperty: true, isText: true },
    { name: 'Job ID', property: 'jobPostId', visible: true, isModelProperty: true, isSecondaryLink: true, secondaryAction: MweConstants.viewAction },
    { name: 'Category', property: 'category', visible: true, isModelProperty: true, isText: true },
    { name: 'Total Applicants', property: 'totalApplicants', visible: true, isModelProperty: true, isSecondaryLink: true, secondaryAction: MweConstants.viewJobApplicationsAction },
    { name: 'Posted Company', property: 'company', visible: true, isModelProperty: true, isText: true },
    { name: 'Country', property: 'country', visible: true, isModelProperty: true, isText: true },
    { name: 'Posted by', property: 'postedBy', visible: true, isModelProperty: true, isText: true },
    { name: 'Email Address', property: 'postedEmail', visible: true, isModelProperty: true, isText: true },
    { name: 'posted On', property: 'createdOn', visible: true, isModelProperty: true, isDatePipe: true },
    { name: 'Status', property: 'active', visible: true, isModelProperty: true, isStatus: true },
    ];
    if(this.hasAddPermission &&!this.hasViewPermission &&!this.hasDeletePermission&&!this.hasEditPermission){
      this.columns=columns;
    }else{
    let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
        actions:[]
              };
              if(this.hasViewPermission){
                action.actions.push({ imageUrl: 'assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
              }
              if(this.hasEditPermission){
                action.actions.push({ imageUrl: 'assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
              }
              if(this.hasDeletePermission){
                action.actions.push({ imageUrl: 'assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
              }

              columns.push(action);
              this.columns=columns;
    }
  }
  onSearch(event: any) {
    let searchValue = '';
    if (typeof event === 'string') {
      searchValue = event;
    } else {
      searchValue = (event.target as HTMLInputElement)?.value?.trim() || '';
    }
    this.searchValue = searchValue;
    this.keyWord = searchValue;
    sessionStorage.setItem(this.SEARCH_STORAGE_KEY, searchValue);
    this.page = 0;
    this.getAllJobPostByFilter();
  }

  selectedAction(event: any) {
    switch (event.action) {
      case MweConstants.addAction:
        if(this.from === 'endCustomer'){
          this.endCustomerSelctedAction.emit({type: 'add'})
          return;
        }
        this.router.navigate(['./post-job'], { relativeTo: this.route });
        break;
      case MweConstants.editAction:
        if(this.from === 'endCustomer'){
          this.endCustomerSelctedAction.emit({type: 'update', id: event.row.id})
          return;
        }
        if (this.searchTerm) {
          sessionStorage.setItem(this.SEARCH_STORAGE_KEY, this.searchTerm);
        }
        this.router.navigate(['./update-job/', event.row.id], { relativeTo: this.route });
        break;
      case MweConstants.deleteAction:
        this.deleteJobPost(event);
        break;
      case MweConstants.viewAction:
        if(this.from === 'endCustomer'){
          this.viewActive.emit(event.row.id);
          return;
        }
        if (this.searchTerm) {
          sessionStorage.setItem(this.SEARCH_STORAGE_KEY, this.searchTerm);
        }
        this.router.navigate(['./view-job', event.row.id], { relativeTo: this.route });
        break;
      case MweConstants.filterAction:
        this.openFilter();
        break;
      case MweConstants.viewJobApplicationsAction:
        if(this.from === 'endCustomer'){
          this.endCustomerSelctedAction.emit({type: 'viewJobApplications', id: event.row.id});
          return;
        }
        this.router.navigate(['./view-job-applications', event.row.id], { relativeTo: this.route });
        break;
      default:
        break;
    }
  }

  convertToLocalDate(dateString: string): string {
    const date = new Date(dateString);
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);
  }

  openFilter() {
    const dialogRef = this.dialog.open(CareerFilterComponent, {
      width: 'auto',
      data: this.filterObject,
      disableClose: true,
      autoFocus: false,
    });

    dialogRef.componentInstance.clearCareersFilter.subscribe(() => {
      this.clearAll();
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.filterObject = result;
        this.isFiltered = true;
        this.updateChips();
        sessionStorage.setItem(this.FILTER_STORAGE_KEY, JSON.stringify(this.filterObject));
        sessionStorage.setItem(this.CHIPS_STORAGE_KEY, JSON.stringify(this.chips));
      } else {
        this.isFiltered = false;
        this.filterObject = {};
        this.chips = [];
        sessionStorage.removeItem(this.FILTER_STORAGE_KEY);
        sessionStorage.removeItem(this.CHIPS_STORAGE_KEY);
      }
      this.getAllJobPostByFilter();
    });
  }

  updateChips() {
    this.chips = [];
    const arrayFields = ['jobCategories', 'skills', 'countries', 'states', 'cities'];
    const singleValueFields = ['postedDate', 'experience', 'company', 'status'];

    Object.keys(this.filterObject).forEach(key => {
      const value = this.filterObject[key];
      if (arrayFields.includes(key) && Array.isArray(value)) {
        value.forEach((item: string) => {
          this.chips.push({ name: item, type: key });
        });
      } else if (singleValueFields.includes(key) && value) {
        let chipName = value;
        if (key === 'postedDate') {
          chipName = this.formatDate(new Date(value));
        } else if (key === 'experience') {
          chipName = `${value} years`;
        }
        this.chips.push({ name: chipName, type: key });
      }
    });
  }
  exportallJobs() {
      const dialogRef = this.dialog.open(ExportComponent, {
        height:'auto',
        width : 'auto',
        data: {
        title: 'Jobs',
        exhibitionId: this.oemId ? this.oemId : ''
        }
      });
      dialogRef.afterClosed().subscribe((result: any)=>{
        if(result === 'Success'){
          this.sweetAlertService.showSuccess(result,"File downloaded Sucessfully!!");
        }
      });
    }

  formatDate(date: Date): string {
    return `${date.toLocaleString('default', { month: 'long' })} ${`0${date.getDate()}`.slice(-2)}, ${date.getFullYear()}`;
  }

  removeChip(chip: { name: string, type: string }) {
    this.chips = this.chips.filter(c => !(c.name === chip.name && c.type === chip.type));
    const arrayFields = ['jobCategories', 'skills', 'countries', 'states', 'cities'];
    if (arrayFields.includes(chip.type)) {
      this.filterObject[chip.type] = this.filterObject[chip.type].filter((item: string) => item !== chip.name);
    } else {
      delete this.filterObject[chip.type];
    }
    sessionStorage.setItem(this.FILTER_STORAGE_KEY, JSON.stringify(this.filterObject));
    sessionStorage.setItem(this.CHIPS_STORAGE_KEY, JSON.stringify(this.chips));
    this.isFiltered = this.chips.length > 0;
    this.page = 0;
    this.getAllJobPostByFilter();
  }

  clearAll() {
    this.chips = [];
    this.filterObject = {};
    this.isFiltered = false;
    sessionStorage.removeItem(this.FILTER_STORAGE_KEY);
    sessionStorage.removeItem(this.CHIPS_STORAGE_KEY);
    this.page = 0;
    this.getAllJobPostByFilter();
  }

  onPageChange(event: any) {
    this.page = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getAllJobPostByFilter();
  }
  getAllJobPost() {
    this.data = [];
    this.userIdByRole = this.careerService.getUserIdBasedOnRole();

    if (this.userIdByRole !== undefined && this.userIdByRole !== null) {
      this.getAllJobPostByFilter();
    } else {
      this.careerService.executeGetRequestURLWithPagination(MweConstants.getJobPostUrl, this.pageSize, this.page, this.keyWord).subscribe(
        (data) => {
          if (data && data?.data && data.data.length > 0) {
            this.data = data.data.map((job:any) => {
              const currentDate = new Date();
              const applicationCloseTime = new Date(job.applicationCloseDate);
              applicationCloseTime.setHours(23, 59, 59, 0);
              applicationCloseTime.setTime(applicationCloseTime.getTime());
              job.active = currentDate <= applicationCloseTime;
              return job;
            });

            this.showNoRecordsFounds = false;
          } else {
            this.showNoRecordsFounds = true;
          }
        }, (error) => {
          this.spinnerService.hideSpinner();
          this.showNoRecordsFounds = true;
        }
      );
    }
  }

  getAllJobPostByFilter() {
    this.showPagination = true;
    this.userIdByRole = this.careerService.getUserIdBasedOnRole();
    const jobPostFilterRequest = { ...this.filterObject, 'userIds': (this.userIdByRole !== undefined && this.userIdByRole !== null) ? [this.userIdByRole] : null };
    this.careerService.getAllJobPostByFilterWithSearchKeyword(jobPostFilterRequest, this.pageSize, this.page, this.keyWord).subscribe(
      (data) => {
        if (data && data?.data) {
          this.data = data.data.map((job:any) => {
            const currentDate = new Date();
            const applicationCloseTime = new Date(job.applicationCloseDate);
              applicationCloseTime.setHours(23, 59, 59, 0);
              applicationCloseTime.setTime(applicationCloseTime.getTime());
            job.active = currentDate <= applicationCloseTime;
            return job;
          });

          this.totalEntries = data.totalCount;
          const totalPages = Math.ceil(data.totalCount / this.pageSize);
          if(this.page >= totalPages - 1){
            this.isPagination = false;
          } else {
            this.isPagination = true;
          }
          this.showPagination = true;
          this.showNoRecordsFounds = false;
        } else if(!data.data || data.data.length === 0){
          this.showPagination = false;
          this.showNoRecordsFounds = true;
          this.totalEntries = this.data.length;
        }
      }, (error) => {
        this.data = [];
        this.showNoRecordsFounds = true;
        this.totalEntries = this.data.length;
      }
    );
    this.careerService.getJobsSummary((this.roleName === 'SUPER_ADMIN') ? ('') : (this.oemId), this.keyWord, jobPostFilterRequest).subscribe((res: any) => {

      this.objects.map((obj: any) => {
        if(obj.code === 'totalJobs') {
          obj.count = res?.data.totalJobs;
        }
        if(obj.code === 'totalActive') {
          obj.count = res?.data.totalActive;
        }
        if(obj.code === 'totalInactive') {
          obj.count = res?.data.totalInactive;
        }
        if(obj.code === 'totalApplicants') {
          obj.count = res?.data.totalApplicants;
        }
      })
    })
  }

  deleteJobPost(event: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover the deleted record!',
      iconHtml: '<img src="./assets/images/group-delete.svg">',
      iconColor: 'white',
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete It',
      confirmButtonColor: '#0f74a9',
      cancelButtonText: 'Cancel',
      cancelButtonColor: '#6c757d'

    }).then((result) => {
      if (result.value) {
        this.deleteJobPostApi(event);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: 'Cancelled',
          text: 'Item is safe.',
          icon: 'error',
          confirmButtonText: 'Ok',
          confirmButtonColor: '#0f74a9',
        });
      }
    });
  }

  deleteJobPostApi(event: any) {
    const userIdByRole = (this.userIdByRole !== undefined && this.userIdByRole !== null) ? this.userIdByRole : null;
    this.careerService.executeDeleteRequestURL(MweConstants.deleteJobPostUrl + event.row.id, null).subscribe({
      next: (data) => {
        if (data && data?.data) {
          Swal.fire({
            title: 'Removed!',
            text: 'Item Removed Successfully.',
            iconHtml: '<img src="./assets/images/confirm-btn.svg">',
            iconColor: 'white',
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0f74a9',
          }).then(result => {
            this.getAllJobPostByFilter();
          });
        }
      }, error: (error) => {
        this.snackbarService.openSnackBar(error.error.error, '');
      }
    });
  }
  close(event: any) {
    this.selectedData = null;
    this.getAllJobPostByFilter();
  }
}
